import React, { useContext, useEffect, useState } from "react";
import { ProjectContext } from "../../context/project_context";
import debounce from 'lodash/debounce';

const ProjectIdentifyTranscriptErrors = () => {
  const { project, updateProject, transcripts, fetchTranscripts, handleMarkTranscriptAsError } = useContext(ProjectContext);
  const [transcriptErrors, setTranscriptErrors] = useState({});
  const [savingStates, setSavingStates] = useState({});
  const [debouncedFunctions] = useState(() => ({}));

  useEffect(() => {
    if (project?.id) {
      fetchTranscripts();
    }
  }, [project?.id]);

  useEffect(() => {
    // Initialize transcript errors from existing data if available
    const initialErrors = {};
    transcripts.forEach(transcript => {
      initialErrors[transcript.id] = transcript.has_error || false;
    });
    setTranscriptErrors(initialErrors);
  }, [transcripts]);

  const handleComplete = async () => {
    await updateProject({
      ...project,
      project_status: "fix_transcript"
    });
  };

  const handleBack = async () => {
    await updateProject({
      ...project,
      project_status: "transcribe_audio"
    });
  };

  const handleErrorToggle = (transcriptId, hasError) => {
    setTranscriptErrors(prev => ({
      ...prev,
      [transcriptId]: hasError
    }));

    if (debouncedFunctions[transcriptId]) {
      debouncedFunctions[transcriptId].cancel();
    }

    if (!debouncedFunctions[transcriptId]) {
      debouncedFunctions[transcriptId] = debounce(async (hasError) => {
        try {
          setSavingStates(prev => ({ ...prev, [transcriptId]: true }));
          const success = await handleMarkTranscriptAsError(transcriptId, hasError);
          if (success) {
            setSavingStates(prev => ({ ...prev, [transcriptId]: false }));
          }
        } catch (error) {
          console.error('Failed to mark/unmark transcript as error:', error);
          setSavingStates(prev => ({ ...prev, [transcriptId]: false }));
        }
      }, 1000);
    }

    debouncedFunctions[transcriptId](hasError);
  };

  return (
    <div className="project-identify-transcript-errors">
      <h2>Identify Transcript Errors</h2>
      <div className="transcript-content">
        <p>Project Name: {project.name}</p>
        
        <div className="transcripts-list mt-3">
          <table className="table table-bordered no-padding">
            <thead>
              <tr>
                <th>T#</th>
                <th>Timeframe</th>
                <th>Content</th>
                <th>Has Error</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {transcripts.map((transcript, index) => (
                <tr key={transcript.id} className={transcriptErrors[transcript.id] ? "table-warning" : ""}>
                  <td style={{ width: '50px' }}>{index + 1}</td>
                  <td style={{ width: '275px' }}>{transcript.timeframe}</td>
                  <td className="p-1">
                    <div className="form-control border-0 rounded-0 bg-transparent">
                      {transcript.text}
                    </div>
                  </td>
                  <td className="text-center" style={{ width: '100px' }}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={transcriptErrors[transcript.id] || false}
                      onChange={(e) => handleErrorToggle(transcript.id, e.target.checked)}
                    />
                  </td>
                  <td>
                    {savingStates[transcript.id] && (
                      <span className="text-muted">Saving...</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="d-flex gap-2 mt-3">
          <button 
            className="btn btn-secondary"
            onClick={handleBack}
          >
            Back to Transcribe
          </button>
          <button 
            className="btn btn-primary"
            onClick={handleComplete}
          >
            Next to Fix Transcript
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectIdentifyTranscriptErrors; 